(ns frontend.ux-overhaul.page-components.navigation.events
  (:require
   [fx.ajax :as ajax]
   [re-frame.core :as rf]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.ux-overhaul.page-components.navigation.subs :as navigation-subs]))

(defn apply-task-badge-counts
  "Put the counts of a `:task/my-unfinished-counts` response into `db`, but only
   when the response belongs to the most recent request. A task mutation
   refetches the counts, so two refreshes can be in flight at once. This drops a
   slow earlier response, so it does not overwrite the latest counts."
  [db request-id resp]
  (if (= request-id (:navigation/task-badge-request-id db))
    (let [body (or (:body resp) resp)]
      (assoc db :navigation/task-badge-counts (:counts body)))
    db))

(rf/reg-event-db
 ::set-task-badge-counts
 (fn [db [_ request-id resp]]
   (apply-task-badge-counts db request-id resp)))

(rf/reg-event-fx
 ::load-task-badge-counts
 ;; The navbar task badge counts the account's own unfinished tasks. A new-grid
 ;; account does not bulk-sync the tasks into the session, so fetch the counts.
 ;; Tag each request with an id and keep the latest id, so a later out-of-order
 ;; response is dropped.
 (fn [{:keys [db]} _]
   (let [request-id (inc (:navigation/task-badge-request-id db 0))]
     {:db (assoc db :navigation/task-badge-request-id request-id)
      ::ajax/send {:operation :task/my-unfinished-counts
                   :body      {}
                   :on-ok     [::set-task-badge-counts request-id]
                   :on-error  [::load-task-badge-counts-failed]}})))

(rf/reg-event-fx
 ::load-task-badge-counts-failed
 ;; A missing badge count is not worth a user-facing error; leave the badge off.
 (fn [_ _]
   {}))

(defn refresh-task-badge-counts!
  "Refetch the navbar task-badge counts after a task mutation, so the persistent
   navbar badge updates without a menu remount. Call it from the success path of
   a task create, complete, reactivate or delete.

   Gate on new-grid here, because the old-grid badge reads the bulk-synced
   session, not the endpoint. This is a plain function. Each caller is a success
   callback, so the session read is outside a re-frame event or subscription
   computation, the same context `bullet` reads the session in."
  []
  (when (session/new-grid-2023?)
    (rf/dispatch [::load-task-badge-counts])))

(rf/reg-event-db
 ::set-active-nav
 (fn [db [_ active-nav]]
   (assoc db :active-nav active-nav)))

(rf/reg-event-db
 ::toggle-modal
 (fn [db _]
   (assoc db :modal-open? (not (:modal-open? db)))))

(rf/reg-event-db
 ::close-modal
 (fn [db _]
   (assoc db :modal-open? false)))

;; Navigation event that calls a modal closing function
(rf/reg-event-fx
 ::navigate-to
 (fn [{:keys [db]} [_ {:keys [path]}]]
   (let [path (if-not (seqable? path) [path] path)]
     {:db (-> db
              (assoc :modal-open? false)
              (assoc :active-nav (first path)))
      ::routing/old-routing {:path-args path}})))

(rf/reg-event-db
 ::show-all-pipelines
 (fn [db _]
   (assoc db :show-all-pipelines? (not (:show-all-pipelines? db)))))

(rf/reg-event-db
 ::show-all-favorites
 (fn [db _]
   (assoc db :show-all-favorites? (not (:show-all-favorites? db)))))

(rf/reg-event-db
 ::toggle-webentries
 (fn [db _]
   (assoc db :show-all-webentries? (not (:show-all-webentries? db)))))
